import { render, staticRenderFns } from "./AdminCaseCreatedModal.vue?vue&type=template&id=70422737"
import script from "./AdminCaseCreatedModal.vue?vue&type=script&lang=js"
export * from "./AdminCaseCreatedModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports